export const GOOGLE_MAPS_API_KEY = 'AIzaSyAL5nKKhlaiwcwOwM6kcTVxjNWSsPlFDvQ';

export const DEFAULT_AVATAR = 'https://rentview.co/img/profile.png';
